export default __webpack_public_path__ + "graphics/pin-map-2.d4d8ed3c.svg";